import ActivateUser from "./ActivateUser";

export default ActivateUser;
